// components
import {
    ReportPageContentHeader,
    ReportPageChatSection,
} from "@components/ReportPage"
import GraphComponent from "@components/ReportPage/GraphComponent/GraphComponent"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import useProfile from "@hooks/useProfile"
import useWindowSize from "@hooks/useWindowSize"
import { Button } from "@components/Button"
// import { ReactComponent as ViewChartIcon } from "@assets/ReportPage/ViewChartIcon.svg"
// import { ReactComponent as ViewReportsIcon } from "@assets/ReportPage/ViewReportsIcon.svg"
import styles from "./ReportPageContent.module.css"

export const ReportPageContent = () => {
    const { handleGetOwnDetails } = useProfile()
    const { width } = useWindowSize()
    const { profileDetails } = useSelector((state) => state.profile)
    const [viewChart, setViewChart] = useState(false)

    const handleView = () => {
        setViewChart(!viewChart)
    }

    const getUiToRender = () => {
        if (width > 920) {
            return (
                <div
                    className={`${styles.GridContainer} h-[90vh] lg:h-[90vh] 3xl:h-[72vh]`}
                >
                    <ReportPageChatSection />
                    <div className="bg-[--bg-theme-lightest] w-full p-6 justify-center items-center rounded-lg">
                        <GraphComponent />
                    </div>
                </div>
            )
        } else {
            return (
                <div className={`${styles.GridContainer} h-[90vh]`}>
                    {viewChart ? (
                        <div className="bg-[--bg-theme-lightest] w-full p-6 justify-center items-center rounded-lg">
                            <GraphComponent />
                        </div>
                    ) : (
                        <ReportPageChatSection />
                    )}
                </div>
            )
        }
    }

    useEffect(() => {
        handleGetOwnDetails()
    }, [])

    return (
        <div className="flex flex-col gap-5 flex-grow pb-5">
            <ReportPageContentHeader profileDetails={profileDetails} />
            {getUiToRender()}
            {width <= 920 ? (
                <Button
                    onClick={handleView}
                    className={`${styles.BottomBtn} max-w-xl mx-auto w-full`}
                    // prependIcon={viewChart ? <ViewReportsIcon /> : <ViewChartIcon />}
                >
                    {" "}
                    {viewChart ? "View Reports" : "View Chart"}
                </Button>
            ) : null}
        </div>
    )
}
